import { render } from "./Overview.vue?vue&type=template&id=1b0d77f3"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/house/Overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b0d77f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b0d77f3', __exports__)) {
    api.reload('1b0d77f3', __exports__)
  }
  
  module.hot.accept("./Overview.vue?vue&type=template&id=1b0d77f3", () => {
    api.rerender('1b0d77f3', render)
  })

}


export default __exports__